export const locale = {
    lang: "pt-BR",
    data: {
        NAV: {
            CADASTROS_SUPER_ADMIN: "Super Admin",
            USERS: "Usuários",
            BULK_COURSE_SUBSCRIPTION: "Inscrições em massa",
            SUBPLATFORM: "Sub Plataforma",
            INVITES: "Convites",
            ADMINS: "Administradores",
            APP: "Voltar ao APP",
            DOWNLOADS: "Downloads",
            CERTIFICATES: "Certificados",
            SUBSCRIPTIONS: "Assinaturas",
            UPLOAD_FILE: "Importação de dados",
            CALENDARS: "Calendários",
            SUBSCRIPTIONTYPES: "Tipos de Assinatura",
            SUBSCRIPTION_DATA: "Dados",
            SUPPORT_CONTACTS: "Contatos de Suporte",
            SUBSCRIPTION_THEME: "Tema",
            SUBSCRIPTION_USER_FIELDS: "Dados adicionais (Usuários)",
            SUBSCRIPTION_FOOTER: "Rodapé Assinatura",
            SUBSCRIPTION_LOGIN_SETTINGS: "Tela de login",
            SUBSCRIPTION_COURSES_CATALOG: "Catálogo de Cursos",
            SUBSCRIPTION_COURSES_CATALOG_OLD: "Catálogo de Cursos (Old)",
            SUBSCRIPTION_CERTIFICATION: "Certificado",
            SUBSCRIPTION_CONTRACT: "Contrato",
            SUBSCRIPTION_PRIVACY_POLICY: "Política de privacidade",
            SUBSCRIPTION_TEMRS_OF_USE: "Termos de uso",
            SUBSCRIPTION_TERMS_OF_PURCHASE: "Termos de compra",
            PLATFORM_CUSTOMIZATION: "Personalização da plataforma",
            HOST_CONFIG: "Host",
            POLICIES_TERMS: "Políticas e termos",
            COMPANY_INFORMATION: "Informações da empresa",
            COURSES: "Cursos (Inscritos)",
            PLANS: "Planos",
            HOME: "Home",
            CONFIGURACOES: "Configurações",
            TROCASENHA: "Trocar senha",
            DATA: "Dados",
            ANALYTICS: "Analytics",
            BILLS: "Faturas",
            GROUPS: "Grupos",
            CATEGORIES: "Categorias",
            TEMPLATES: "Templates",
            DOCS: "Documentação",
            LEARNING_PATH: "Trilhas",
            ACHIEVEMENTS: "Conquistas",
            CHECKOUT: "Checkout",
            BILLING_ACCOUNTS: "Contas",
            EAD: "EAD",
            CADASTROS: "Cadastros",
            PAYMENTS: "Pagamentos",
            CONFIGURATIONS: "Configurações",
            AFFILIATES: "Afiliados",
            SPLITRULE: "Divisão de pagamento",
            COUPONS: "Cupons",
            COUPONS_SALES_HISTORY: "Histórico de vendas",
            IUGU: {
                REPORT: "Relatório"
            },
            DATA_ANALYSIS_SETTINGS: "Ferramentas Analytics",
            FISCAL: "Fiscal",
            INVOICE_GATEWAYS: "Gateways",
            INVOICE_REPORT: "Notas",
            WEBHOOKS_CONFIGS: "Configurações",
            WEBHOOKS_EVENTS: "Eventos",
            STORAGE: {
                TITLE: "Biblioteca",
                REPORT: "Relatório de consumo"
            },
            GAMIFICATION: {
                TITLE: "Gamificação",
                GAMIFICATION_CONFIGS: "Configurações",
                ACHIEVEMENTS: "Conquistas",
                RANKINGS: "Rankings",
                LEADERBOARDS: "Classificações",
                REPORT: "Relatório",
                DETAILS: "Pontuações"
            },
            RelatorioGraficos: "Relatórios & Gráficos"
        }
    }
};
